import { skipToken } from "@reduxjs/toolkit/query";

import { useVaultDisclosuresQuery } from "../../reducers/vaultDisclosuresPublicApi";
import { VaultDisclosuresResponse } from "../../types";

export function useVaultDisclosuresDomain({ vaultAddress }: { vaultAddress: string | undefined }): {
    data: VaultDisclosuresResponse | undefined;
    isLoading: boolean;
    isFetching: boolean;
    isError: boolean;
} {
    const query = useVaultDisclosuresQuery(vaultAddress ? { address: vaultAddress } : skipToken);
    return {
        data: query.data,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isError: query.isError
    };
}
